// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610132105/js/" + chunkId + "." + {"44":"f6307d9c","225":"dc33e1b6","481":"0fe88061","486":"e8b5f3d2","770":"bf37d1b7"}[chunkId] + ".0.24197998152550415.chunk.js";
};